/* Algemene interacties — byTons Wonen
 * Alles hier is defensief: een sectie kan op een pagina ontbreken.
 */
(function(){
  'use strict';

  var $  = function(sel, root){ return (root || document).querySelector(sel); };
  var $$ = function(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* -------------------------------------------------- menubalk bij scrollen */

  var header = $('#siteHeader');
  if(header){
    var opScroll = function(){ header.classList.toggle('scrolled', window.scrollY > 8); };
    document.addEventListener('scroll', opScroll, { passive: true });
    opScroll();
  }

  /* -------------------------------------------------- uitschuifmenu */

  var menuKnop = $('#menuToggle'), lade = $('#drawer'), ladeDicht = $('#drawerClose'), scrim = $('#scrim');
  function openMenu(){
    if(!lade) return;
    lade.classList.add('open');
    if(scrim) scrim.classList.add('open');
    if(menuKnop) menuKnop.setAttribute('aria-expanded', 'true');
  }
  function sluitMenu(){
    if(!lade) return;
    lade.classList.remove('open');
    if(scrim) scrim.classList.remove('open');
    if(menuKnop) menuKnop.setAttribute('aria-expanded', 'false');
  }
  if(menuKnop) menuKnop.addEventListener('click', openMenu);
  if(ladeDicht) ladeDicht.addEventListener('click', sluitMenu);
  if(scrim) scrim.addEventListener('click', sluitMenu);
  if(lade) $$('a', lade).forEach(function(a){ a.addEventListener('click', sluitMenu); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') sluitMenu();
  });

  /* -------------------------------------------------- rustig invaren */

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(rijen){
      rijen.forEach(function(rij){
        if(rij.isIntersecting){ rij.target.classList.add('in'); io.unobserve(rij.target); }
      });
    }, { threshold: .12 });
    $$('.reveal').forEach(function(el){ io.observe(el); });
  }else{
    $$('.reveal').forEach(function(el){ el.classList.add('in'); });
  }

  /* -------------------------------------------------- ankerlinks */

  $$('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href').slice(1);
      if(!id) return;
      var doel = document.getElementById(id);
      if(doel){
        e.preventDefault();
        doel.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    });
  });

  /* -------------------------------------------------- uitklappers */

  $$('.accordion-head').forEach(function(kop){
    kop.addEventListener('click', function(){
      var item = kop.parentElement;
      if(item) item.classList.toggle('open');
    });
  });

  /* -------------------------------------------------- productgalerij */

  var hoofdFoto = $('[data-pd-main]');
  if(hoofdFoto){
    $$('[data-pd-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        var bron = thumb.getAttribute('data-pd-thumb');
        if(!bron) return;
        hoofdFoto.style.backgroundImage = "url(" + bron + ")";
        $$('[data-pd-thumb]').forEach(function(t){ t.classList.toggle('active', t === thumb); });
      });
    });
  }

  /* -------------------------------------------------- aantal op de productpagina */

  var aantalVeld = $('[data-qty-input]');
  if(aantalVeld){
    $$('[data-qty-stap]').forEach(function(knop){
      knop.addEventListener('click', function(){
        var stap = parseInt(knop.getAttribute('data-qty-stap'), 10);
        var nu = parseInt(aantalVeld.value, 10) || 1;
        aantalVeld.value = Math.max(1, nu + stap);
        var toon = $('[data-qty-toon]');
        if(toon) toon.textContent = aantalVeld.value;
      });
    });
  }
})();

/* Aanbevelingen ophalen na het laden (Shopify Product Recommendations API).
   De sectie vervangt zichzelf door de opgehaalde versie. */
(function(){
  'use strict';
  function haal(url){
    return fetch(url).then(function(r){ return r.text(); }).then(function(tekst){
      var nieuw = new DOMParser().parseFromString(tekst, 'text/html')
                     .querySelector('[data-aanbevelingen]');
      return (nieuw && nieuw.innerHTML.trim()) ? nieuw.innerHTML : '';
    });
  }

  document.querySelectorAll('[data-aanbevelingen]').forEach(function(vak){
    var url = vak.getAttribute('data-url');
    var reserve = vak.getAttribute('data-url-reserve');
    if(!url) return;

    haal(url)
      .then(function(html){
        // Niets ingesteld? Dan de suggesties die Shopify zelf berekent.
        if(html || !reserve) return html;
        return haal(reserve);
      })
      .then(function(html){ if(html) vak.innerHTML = html; })
      .catch(function(){ /* geen aanbevelingen: het blok blijft leeg */ });
  });
})();

/* Shop de look: stippen op de sfeerfoto openen een productkaartje.
   Op mobiel licht een tik op de stip de kaart onder de foto op. */
(function(){
  'use strict';
  document.querySelectorAll('.stl-sectie').forEach(function(sectie){
    var beeld = sectie.querySelector('.stl-beeld');
    if(!beeld) return;

    function kaartje(nr){ return sectie.querySelector('[data-stl-kaartje="' + nr + '"]'); }
    function sluitAlles(){
      sectie.querySelectorAll('.stl-kaartje.open').forEach(function(k){ k.classList.remove('open'); });
      sectie.querySelectorAll('.stl-spot.open').forEach(function(s){ s.classList.remove('open'); });
    }

    sectie.querySelectorAll('.stl-spot').forEach(function(spot){
      spot.addEventListener('click', function(e){
        e.stopPropagation();
        var nr = spot.getAttribute('data-stl');
        var k = kaartje(nr);
        var wasOpen = spot.classList.contains('open');
        sluitAlles();
        if(wasOpen || !k) return;

        // het kaartje binnen de foto houden
        var x = parseInt(k.getAttribute('data-x'), 10);
        var y = parseInt(k.getAttribute('data-y'), 10);
        k.style.setProperty('--tx', x > 78 ? '-88%' : (x < 22 ? '-12%' : '-50%'));
        k.style.setProperty('--ty', y > 62 ? 'calc(-100% - 16px)' : '16px');

        spot.classList.add('open');
        k.classList.add('open');

        // de bijbehorende kaart in de rij even laten oplichten
        var product = sectie.querySelector('[data-stl-product="' + nr + '"]');
        if(product){
          product.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          product.classList.remove('pulse');
          void product.offsetWidth;
          product.classList.add('pulse');
        }
      });
    });

    document.addEventListener('click', sluitAlles);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') sluitAlles(); });
  });
})();

/* Compleet de look: haalt de twee bijpassende artikelen op die in Shopify
   bij dit product zijn ingesteld. Niets ingesteld = blok blijft onzichtbaar. */
(function(){
  'use strict';
  var vak = document.querySelector('[data-bundel]');
  if(!vak || !vak.getAttribute('data-url')) return;

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function geld(centen){
    return window.byTonsGeld ? window.byTonsGeld(centen)
      : '€ ' + (centen / 100).toFixed(2).replace('.', ',');
  }

  fetch(vak.getAttribute('data-url'), { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(function(d){
      var ps = (d.products || []).filter(function(p){ return p.available !== false; }).slice(0, 2);
      if(!ps.length) return;

      var houder = vak.querySelector('[data-bundel-items]');
      var knop = vak.querySelector('[data-bundel-knop]');
      var totaalEl = vak.querySelector('[data-bundel-totaal]');
      var totaal = parseInt(vak.getAttribute('data-basis'), 10) || 0;
      var ids = [vak.getAttribute('data-basis-variant')];

      ps.forEach(function(p){
        totaal += p.price;
        if(p.variants && p.variants[0]) ids.push(p.variants[0].id);
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : p.featured_image;
        houder.insertAdjacentHTML('beforeend',
          '<span class="bundel-plus" aria-hidden="true">+</span>' +
          '<div class="bundel-item">' +
            '<a href="' + esc(p.url) + '"><div class="cart-thumb"' +
              (img ? ' style="background-image:url(' + esc(img) + ')"' : '') + '></div></a>' +
            '<p class="bundel-naam">' + esc(p.title) + '</p>' +
            '<p class="bundel-prijs">' + geld(p.price) + '</p>' +
          '</div>');
      });

      knop.setAttribute('data-bundel', ids.filter(Boolean).join(','));
      totaalEl.textContent = geld(totaal);
      vak.hidden = false;
    })
    .catch(function(){ /* geen set ingesteld: blok blijft weg */ });
})();

/* Collectiefilters — zelfde werking als het oorspronkelijke ontwerp:
   aanvinken filtert direct, tellers tellen mee, chips tonen de keuze. */
(function(){
  'use strict';
  var grid = document.getElementById('collGrid');
  if(!grid) return;

  var alleKaarten = [].slice.call(grid.querySelectorAll('.product-card'));
  var boxes = [].slice.call(document.querySelectorAll('.fopt input'));
  var priceRange = document.getElementById('priceRange');
  var priceOut = document.getElementById('priceOut');
  var visCount = document.getElementById('visCount');
  var totalCount = document.getElementById('totalCount');
  var chipsBox = document.getElementById('activeChips');
  var noResults = document.getElementById('noResults');
  var maxprijs = priceRange ? parseInt(priceRange.max, 10) : 0;

  function selected(g){
    return boxes.filter(function(b){ return b.dataset.group === g && b.checked; })
                .map(function(b){ return b.value; });
  }

  function verversOpties(){
    ['collectie', 'soort', 'kleur', 'materiaal'].forEach(function(groep){
      var aantallen = {};
      alleKaarten.forEach(function(c){
        var v = c.dataset[groep];
        if(!v) return;
        // Een product zit in meerdere collecties; de rest heeft één waarde.
        (groep === 'collectie' ? v.split(/\s+/) : [v]).forEach(function(w){
          if(w) aantallen[w] = (aantallen[w] || 0) + 1;
        });
      });
      document.querySelectorAll('.fopt input[data-group="' + groep + '"]').forEach(function(input){
        var label = input.closest('.fopt');
        var n = aantallen[input.value] || 0;
        label.classList.toggle('leeg', n === 0);
        label.querySelector('.fcount').textContent = n;
      });
    });
  }

  function renderChips(waarden, maxPrice){
    chipsBox.innerHTML = '';
    waarden.forEach(function(w){
      var chip = document.createElement('span');
      chip.className = 'chip';
      chip.innerHTML = w.label + ' <button aria-label="Verwijder filter">&times;</button>';
      chip.querySelector('button').addEventListener('click', function(){
        boxes.forEach(function(b){ if(b.value === w.value) b.checked = false; });
        apply();
      });
      chipsBox.appendChild(chip);
    });
    if(priceRange && maxPrice < maxprijs){
      var chip = document.createElement('span');
      chip.className = 'chip';
      chip.innerHTML = 'Tot € ' + maxPrice + ' <button aria-label="Verwijder prijsfilter">&times;</button>';
      chip.querySelector('button').addEventListener('click', function(){
        priceRange.value = maxprijs; priceOut.textContent = '€ ' + maxprijs; apply();
      });
      chipsBox.appendChild(chip);
    }
  }

  function apply(){
    var col = selected('collectie');
    var s = selected('soort'), k = selected('kleur'), m = selected('materiaal');
    var maxPrice = priceRange ? parseInt(priceRange.value, 10) : Infinity;
    var shown = 0;
    alleKaarten.forEach(function(c){
      var eigen = (c.dataset.collectie || '').split(/\s+/);
      var ok = (!col.length || col.some(function(h){ return eigen.indexOf(h) > -1; }))
            && (!s.length || s.indexOf(c.dataset.soort) > -1)
            && (!k.length || k.indexOf(c.dataset.kleur) > -1)
            && (!m.length || m.indexOf(c.dataset.materiaal) > -1)
            && parseInt(c.dataset.prijs, 10) <= maxPrice;
      c.classList.toggle('hide', !ok);
      if(ok) shown++;
    });
    if(visCount) visCount.textContent = shown;
    // totalCount blijft ongemoeid: dat is het echte aantal in de collectie
    // (collection.products_count vanuit Liquid), niet het aantal op deze
    // pagina. Dat cijfer verandert niet door te filteren.
    if(noResults) noResults.classList.toggle('show', shown === 0);
    var actief = boxes.filter(function(b){ return b.checked; })
      .map(function(b){ return { value: b.value, label: b.getAttribute('data-label') || b.value }; });
    renderChips(actief, maxPrice);
  }

  boxes.forEach(function(b){ b.addEventListener('change', apply); });
  if(priceRange){
    priceRange.addEventListener('input', function(){
      priceOut.textContent = '€ ' + priceRange.value; apply();
    });
  }
  var wis = document.getElementById('clearAll');
  if(wis) wis.addEventListener('click', function(){
    boxes.forEach(function(b){ b.checked = false; });
    if(priceRange){ priceRange.value = maxprijs; priceOut.textContent = '€ ' + maxprijs; }
    apply();
  });

  document.querySelectorAll('.fgroup-head').forEach(function(h){
    h.addEventListener('click', function(){ h.closest('.fgroup').classList.toggle('open'); });
  });

  var filters = document.getElementById('filters');
  var fScrim = document.getElementById('filterScrim');
  var fToggle = document.getElementById('filterToggle');
  if(fToggle) fToggle.addEventListener('click', function(){
    filters.classList.add('open'); fScrim.classList.add('open');
  });
  if(fScrim) fScrim.addEventListener('click', function(){
    filters.classList.remove('open'); fScrim.classList.remove('open');
  });

  var sortBy = document.getElementById('sortBy');
  if(sortBy) sortBy.addEventListener('change', function(e){
    var mode = e.target.value, sorted = alleKaarten.slice();
    if(mode === 'laag') sorted.sort(function(a, b){ return a.dataset.prijs - b.dataset.prijs; });
    else if(mode === 'hoog') sorted.sort(function(a, b){ return b.dataset.prijs - a.dataset.prijs; });
    else if(mode === 'nieuw') sorted.sort(function(a, b){
      var an = a.querySelector('.badge'), bn = b.querySelector('.badge');
      return (bn ? 1 : 0) - (an ? 1 : 0);
    });
    sorted.forEach(function(c){ grid.appendChild(c); });
  });

  verversOpties();
  apply();
})();

/* Galerij-lightbox op de overnachten-pagina. */
(function(){
  'use strict';
  var lb = document.getElementById('lightbox');
  var items = [].slice.call(document.querySelectorAll('.gal-item'));
  if(!lb || !items.length) return;

  var lbImg = document.getElementById('lbImg');
  var idx = 0;
  function show(i){
    idx = (i + items.length) % items.length;
    var foto = items[idx].querySelector('.photo');
    lbImg.style.backgroundImage = foto ? getComputedStyle(foto).backgroundImage : '';
    lb.classList.add('open');
  }
  items.forEach(function(it, i){ it.addEventListener('click', function(){ show(i); }); });
  document.getElementById('lbClose').addEventListener('click', function(){ lb.classList.remove('open'); });
  document.getElementById('lbPrev').addEventListener('click', function(e){ e.stopPropagation(); show(idx - 1); });
  document.getElementById('lbNext').addEventListener('click', function(e){ e.stopPropagation(); show(idx + 1); });
  lb.addEventListener('click', function(e){ if(e.target === lb) lb.classList.remove('open'); });
  document.addEventListener('keydown', function(e){
    if(!lb.classList.contains('open')) return;
    if(e.key === 'Escape') lb.classList.remove('open');
    if(e.key === 'ArrowLeft') show(idx - 1);
    if(e.key === 'ArrowRight') show(idx + 1);
  });
})();

/* Beoordelingslabel: pas tonen als de bezoeker voorbij het eerste scherm is.
   Zo ligt het nooit over een knop bovenaan de pagina — een eis uit het
   ontwerp: het label mag de inhoud niet overschaduwen. */
(function(){
  'use strict';
  var chip = document.querySelector('.rating-chip');
  if(!chip) return;
  chip.classList.add('wacht');
  function kijk(){
    chip.classList.toggle('zichtbaar', window.scrollY > window.innerHeight * 0.6);
  }
  document.addEventListener('scroll', kijk, { passive: true });
  window.addEventListener('resize', kijk);
  kijk();
})();

/* Productfoto vergroten: tik op het beeld opent het schermvullend.
   Bij woonaccessoires wil een klant de structuur van riet, hout of keramiek
   van dichtbij kunnen zien. */
(function(){
  'use strict';
  var vlak = document.querySelector('.pd-gallery-main');
  var laag = document.getElementById('pdZoom');
  if(!vlak || !laag) return;

  var doel = document.getElementById('pdZoomImg');
  var sluitKnop = document.getElementById('pdZoomSluit');

  function open(){
    var foto = vlak.querySelector('.photo');
    if(!foto) return;
    doel.style.backgroundImage = getComputedStyle(foto).backgroundImage;
    laag.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function sluit(){
    laag.classList.remove('open');
    document.body.style.overflow = '';
  }

  vlak.addEventListener('click', open);
  sluitKnop.addEventListener('click', sluit);
  laag.addEventListener('click', function(e){ if(e.target === laag) sluit(); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && laag.classList.contains('open')) sluit();
  });
})();

/* Boekbalk op de overnachten-pagina: in beeld tussen het sfeerbeeld en het
   boekingsblok, want daar staat de knop al. */
(function(){
  'use strict';
  var balk = document.querySelector('[data-boek-balk]');
  if(!balk) return;

  var hero = document.querySelector('.stay-hero');
  var boeken = document.getElementById('boeken');

  function kijk(){
    var voorbijHero = hero ? hero.getBoundingClientRect().bottom < 60 : window.scrollY > 300;
    var boekenInBeeld = boeken
      ? boeken.getBoundingClientRect().top < window.innerHeight * 0.85
      : false;
    balk.classList.toggle('zichtbaar', voorbijHero && !boekenInBeeld);
  }

  document.addEventListener('scroll', kijk, { passive: true });
  window.addEventListener('resize', kijk);
  kijk();
})();

/* Zoeken: overlay met resultaten terwijl je typt.
   Gebruikt Shopify's eigen voorspellende zoekfunctie — geen app nodig.
   In de demo wordt deze functie overschreven door een lokale zoekactie. */
(function(){
  'use strict';
  var knop = document.getElementById('zoekKnop');
  var laag = document.getElementById('zoekLaag');
  if(!knop || !laag) return;

  var veld = document.getElementById('zoekVeld');
  var uit = document.getElementById('zoekUitslag');
  var sluitKnop = document.getElementById('zoekSluit');
  var timer;

  function open(){
    laag.hidden = false;
    requestAnimationFrame(function(){
      laag.classList.add('open');
      veld.focus({ preventScroll: true });
    });
  }
  function sluit(){
    laag.classList.remove('open');
    setTimeout(function(){ laag.hidden = true; }, 250);
  }

  knop.addEventListener('click', open);
  sluitKnop.addEventListener('click', sluit);
  laag.addEventListener('click', function(e){ if(e.target === laag) sluit(); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && !laag.hidden) sluit();
  });

  function geld(centen){
    return window.byTonsGeld ? window.byTonsGeld(centen)
      : '€ ' + (centen / 100).toFixed(2).replace('.', ',');
  }

  veld.addEventListener('input', function(){
    var q = veld.value.trim();
    clearTimeout(timer);
    if(q.length < 2){ uit.innerHTML = ''; return; }
    timer = setTimeout(function(){
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product&resources[limit]=8';
      fetch(url)
        .then(function(r){ return r.json(); })
        .then(function(d){
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if(!ps.length){
            uit.innerHTML = '<p class="zoek-leeg">Niets gevonden voor “' + q + '”.</p>';
            return;
          }
          uit.innerHTML = ps.map(function(p){
            var foto = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            var prijs = p.price ? geld(parseInt(p.price, 10)) : '';
            return '<a class="zoek-rij" href="' + p.url + '">'
              + '<span class="cart-thumb"' + (foto ? ' style="background-image:url(' + foto + ')"' : '') + '></span>'
              + '<span class="zoek-naam">' + p.title + '</span>'
              + '<span class="zoek-prijs">' + prijs + '</span></a>';
          }).join('');
        })
        .catch(function(){ uit.innerHTML = ''; });
    }, 220);
  });
})();
